export default class UserResource {
  constructor(client) {
    this.client = client;
  }

  list() {
    return this.client.get("/users").then((resp) => resp.data);
  }
  create(user) {
    return this.client.post("/users", user).then((resp) => resp.data);
  }
  update(user) {
    return this.client
      .patch("/users/" + user.id, user)
      .then((resp) => resp.data);
  }
  delete(userId) {
    return this.client.delete("/users/" + userId);
  }
}
